import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { SectionOutput } from 'infrastructure/graphql/content/section/model/section.output';
import { SectionType } from 'phase/model/section/section.type';
import { SectionConverterPort } from 'phase/section/port/section-converter.port';
import { Section } from 'phase/section/section';
import { SectionI18n } from 'phase/section/section-i18n';

@Injectable()
export class SectionConverterAdapter
	extends ApplicationAdapter
	implements SectionConverterPort
{
	public sectionAsEntity(output: SectionOutput, phaseId: string): Section {
		if (!output) {
			return null;
		}

		return new Section(
			output.id,
			phaseId,
			output.position,
			SectionType[output.type],
			output.updateTimestamp,
			output.localizations.map((loc) => new SectionI18n(loc.name, loc.locale))
		);
	}

	public sectionsAsEntities(
		outputs: SectionOutput[],
		phaseId: string
	): Section[] {
		return reject(outputs, isNil).map((output) =>
			this.sectionAsEntity(output, phaseId)
		);
	}
}
